/**
 * currentNumberOfDays constants
 */
export const SET_CURRENT_NUMBER_OF_DAYS = 'SET_CURRENT_NUMBER_OF_DAYS';
